import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CheckCircle, Mail, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';

export default function OrderSuccessPage() {
  const location = useLocation();
  const orderNumber = location.state?.orderNumber || 'FAZ-2024-XXX';

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: [0.34, 1.56, 0.64, 1] }}
        className="max-w-lg w-full text-center"
      >
        {/* Success icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, duration: 0.4, ease: [0.34, 1.56, 0.64, 1] }}
          className="flex items-center justify-center mb-8"
        >
          <div className="h-24 w-24 rounded-full bg-primary/10 flex items-center justify-center">
            <CheckCircle size={52} className="text-primary" strokeWidth={1.5} />
          </div>
        </motion.div>

        <h1 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
          Hvala na porudzbini!
        </h1>

        <p className="text-muted-foreground font-body-serif text-lg mb-6 leading-relaxed">
          Uspešno ste poručili. Potvrda će stići na mejl.
        </p>

        {/* Order number */}
        <div className="bg-card border border-border rounded-xl p-6 mb-6 shadow-card">
          <p className="text-sm text-muted-foreground font-ui mb-1">Broj porudžbine</p>
          <p className="font-serif text-2xl font-bold text-primary">{orderNumber}</p>
        </div>

        <div className="bg-accent/60 rounded-xl p-5 mb-8 flex items-start gap-3 text-left">
          <Mail size={20} className="text-primary shrink-0 mt-0.5" />
          <div>
            <p className="font-ui text-sm font-medium text-foreground mb-1">Potvrda na email</p>
            <p className="text-xs text-muted-foreground font-ui leading-relaxed">
              Potvrda porudžbine biće poslata na email koji ste uneli prilikom kupovine.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/proizvodi">
            <Button
              className="bg-primary text-primary-foreground hover:bg-primary-light font-ui w-full sm:w-auto"
            >
              Nastavi kupovinu
              <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
          <Link to="/">
            <Button
              variant="outline"
              className="border-border font-ui w-full sm:w-auto hover:border-primary hover:text-primary"
            >
              Početna
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
